import React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./StatusCalendar.css";

function formatStatusDate(date) {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function isFutureDate(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date > today;
}

const statusLabels = [
  { code: "2", label: "APPROVED", className: "tile-approved" },
  { code: "1", label: "NOT APPROVED", className: "tile-not-approved" },
  { code: "4", label: "WEEKOFF", className: "tile-weekoff" },
  { code: "5", label: "HOLIDAY", className: "tile-holiday" },
  { code: "0", label: "NOT UPDATED", className: "tile-not-updated" },
  { code: "6", label: "LEAVE", className: "tile-leave" },
  { code: "7", label: "ONDUTY", className: "tile-onduty" },
  // Optional:
  { code: "8", label: "ABSENT", className: "tile-absent" },
  { code: "9", label: "SELECTED DATE", className: "tile-selected" },
];

export default function StatusCalendar({ selectedDate, setSelectedDate,dateStatusMap,setActiveStartDate,legendGrid=true }) {
   const dateStatusLookup = {};
    dateStatusMap.forEach(item => {
    dateStatusLookup[item.t_date] = item.app_status;
  });

  function getStatusClass(date) {
    //   if (date.getDay() === 0 || date.getDay() === 6) {
    //   return "tile-weekoff";
    // }
    const formattedDate = formatStatusDate(date);
    const statusCode = dateStatusLookup[formattedDate];
    const status = statusLabels.find(s => s.code === statusCode);
    return status ? status.className : "";
  }

  // function isDisabledSelectedDate(selectedDate) {
  //   if (!selectedDate) return false;
 
  //   const dateObj =
  //     selectedDate instanceof Date
  //       ? selectedDate
  //       : new Date(selectedDate);
 
  //   return isFutureDate(dateObj) || isApiDisabledDate(dateObj);
 // }

  return (
    <div>
        <Calendar
          onChange={setSelectedDate}
          value={selectedDate}
        //  value={
        //     isDisabledSelectedDate(selectedDate)
        //       ? null           // ⛔ prevents highlighting disabled date
        //       : selectedDate
        //   }
          tileClassName={({ date, view }) => {
            if (view !== "month") return "";

            const formattedDate = formatStatusDate(date);
            const classes = [];

            if (!isFutureDate(date)) {
              const statusClass = getStatusClass(date);
              if (statusClass) classes.push(statusClass);
            }

            if (formattedDate === formatStatusDate(selectedDate)) {
              classes.push("tile-selected");
            }

            return classes.join(" ");
          }}

          tileDisabled={({ date, view }) =>
            view === "month" && isFutureDate(date)
          }
          onActiveStartDateChange={({ activeStartDate, view }) => {
            if (view === "month") {
              setActiveStartDate(activeStartDate)
            }
          }}
          onClickDay={(date) => {
            console.log("Clicked date:", date);
            setSelectedDate(formatStatusDate(date));
          }}
        />
        {legendGrid && (
            <div
              className="legend-grid"
              style={{
                marginTop: 16,
                display: "grid",
                gridTemplateColumns: "repeat(3, auto)",
                gap: "16px 5px",
                justifyContent: "center",
                fontWeight: "600",
              gridGap: "10px",
              columnGap: "15px",
              }}
            >
              {statusLabels.map(({ label, className, code }) => (
                <div
                  key={code}
                  className="legend-item"
                  style={{ display: "flex", alignItems: "center", gap: 8,fontSize: "12px", color: "#333" }}
                >
                  <span
                    className={`color-box ${className}`}
                    style={{
                      width: 14,
                      height: 14,
                      borderRadius: 4,
                      display: "inline-block",
                    }}
                  />
                  {label}
                </div>
              ))}
            </div>
        )}
    </div>
  );
}
